<template>
  <WdsTooltip v-if="overwritten" global top>
    <WdsText secondary>
      {{ $t('Overridden') }}
    </WdsText>
    <template #tooltip-content>
      {{ reason }}
    </template>
  </WdsTooltip>
  <WdsText :sub-text="column.classificationLabel ?? ''" :title="label">
    {{ short }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText, WdsTooltip } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { FragmentType, graphql, useFragment } from '@/gql'

const HireClassificationColumn = graphql(`
  fragment HireClassificationColumn on Hire {
    contractType
    contractTypeShort
    contractTypeLabel
    classificationLabel
    classificationResult

    wcr {
      id
      overridesAnother
      user {
        id
        name
      }
      supersededBy {
        reason
        type
        filedAt
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof HireClassificationColumn> }>()
const column = computed(() => useFragment(HireClassificationColumn, props.row))

const short = computed(() => column.value.contractTypeShort)
const label = computed(() => column.value.contractTypeLabel)

const overwritten = computed(() => column.value.wcr?.overridesAnother ?? false)
const reason = computed(() =>
  $t(`The original classification was overridden by :user for the following reason: :reason`, {
    reason: column.value.wcr?.supersededBy?.reason ?? '',
    user: column.value.wcr?.user?.name ?? '',
  }),
)
</script>
